import { Route, Routes, useLocation } from "react-router-dom";
import Dashboard from "../scenes/dashboard/index";
import OverView from "../scenes/OverView/OverView";
import CircularProgress from "@mui/material/CircularProgress";
import React, { Suspense, useEffect } from "react";
import { menu, mobileNotifcation } from "./MobileRoute.js";
import {
  LazyDepositDocument,
  LazyOrderPaymentArchive,
  LazyOrderPaymentFinancial,
} from "./OrderPaymentRoute.js";
import {
  LazyFinancialTransaction,
  LazyFinancialTransactionCategory,
  LazyCalenderEvent,
  LazyListOfLoan,
  LazyMafsaInsuranceReport,
  LazyPettyCashList,
} from "./FinancialRoute.js";
import NotFound from "../Pages/NotFound/index.jsx";
const token = JSON.parse(localStorage.getItem("userInfo"));
const LazyOrders = React.lazy(() => import("../scenes/Orders/Orders.js"));
const LazyDesigner = React.lazy(() => import("../scenes/Designer/index.js"));
const LazyQc = React.lazy(() => import("../scenes/Production/Qc/index.js"));
const LazyLetters = React.lazy(() => import("../scenes/Letters/index.js"));
const LazyFinancialReportCharts = React.lazy(() => import("../scenes/Financial/FinancialTransaction/FinancialReportCharts/FinancialReportCharts"));
const LazDamageCorrectiveAction = React.lazy(() =>
  import("../scenes/DamageCorrectiveAction/index")
);

const lazyOrderDamageManager = React.lazy(() =>
  import("../scenes/orderDamage/manager/index.js")
);
const lazyReasonsCancellationFailure = React.lazy(() =>
  import("../scenes/ReasonsCancellationFailure/index.js")
);
const lazyOrderDamageFinancial = React.lazy(() =>
  import("../scenes/orderDamage/financial/index.js")
);
const lazyOrderDamageArchived = React.lazy(() =>
  import("../scenes/orderDamage/archived/index.js")
);
const lazyOrderDamageSupervisor = React.lazy(() =>
  import("../scenes/orderDamage/supervisor/index.js")
);
const lazyOrderDamageMainPage = React.lazy(() =>
  import("../scenes/orderDamage/MainPage/index.js")
);

// clueCustomer
const LazyClueCustomer = React.lazy(() =>
  import("../scenes/SaleLead/index.js")
);
const LazyScheduler = React.lazy(() => import("../scenes/Scheduler/index.js"));

const LazyFormAfzarOrders = React.lazy(() =>
  import("../scenes/Production/FormAfzarOrders/FormAfzarOrders")
);
const lazyCustomerArchivedOrders = React.lazy(() =>
  import("../scenes/CustomerArchivedOrders/index.js")
);
const LazyAssistant = React.lazy(() =>
  import("../scenes/PrintAssistant/index.js")
);

const lazySentCartablePerson = React.lazy(() =>
  import("../scenes/PersonFroms/SentCartablePerson/SentCartablePerson.jsx")
);
const LazyFailureInvestigation = React.lazy(() =>
  import("../scenes/FailureInvestigation/mainPage/index.js")
);

const LazyArchivedPlateDamaged = React.lazy(() =>
  import("../scenes/FailureInvestigation/Archive/ArchivedPlateDamaged")
);

const LazyManagerLazyFailureInvestigation = React.lazy(() =>
  import("../scenes/FailureInvestigation/Manager/ManagerFailureInvestigation")
);

const lazyFinancial = React.lazy(() =>
  import("../scenes/Production/Financial/index.js")
);

const lazyPlates = React.lazy(() =>
  import("../scenes/ConsumableMaterial/Plates/Plates")
);

const lazyCausesFailure = React.lazy(() =>
  import("../scenes/ConsumableMaterial/CausesFailure/CausesFailure")
);

const lazyProductionQC = React.lazy(() =>
  import("../scenes/Production/ProductionQC/ProductionQC")
);

const LazyLaser = React.lazy(() =>
  import("../scenes/Production/Laser/Laser.js")
);
const LazyLaserDigital = React.lazy(() =>
  import("../scenes/Production/Laser/Digital/Digital.js")
);
const LazyRep = React.lazy(() => import("../scenes/Production/Rep/index.js"));

const LazyQualityControl = React.lazy(() =>
  import("../scenes/Qualitycontrol/Customers.js")
);

const LazySales = React.lazy(() => import("../scenes/Sales/Sales"));

const LazyOnlineOrder = React.lazy(() =>
  import("../scenes/OnlineOrder/OnlineOrder.js")
);
const LazyOrderArchive = React.lazy(() =>
  import("../scenes/Production/OrderArchive/ArchiveTable.js")
);
const LazyTicket = React.lazy(() => import("../scenes/Ticket/Ticket"));
/*================================ ConsumableMaterial ==============================*/
const LazyColorAngle = React.lazy(() =>
  import("../scenes/ConsumableMaterial/ColorAngle/ColorAngle.jsx")
);
const LazyDefinitionKlische = React.lazy(() =>
  import("../scenes/ConsumableMaterial/Klische/DefinitionKlische.js")
);
const LazyInfoMachine = React.lazy(() =>
  import("../scenes/ConsumableMaterial/InfoMachine/InfiMachine.js")
);
const LazyKlischeThikness = React.lazy(() =>
  import("../scenes/ConsumableMaterial/KlischeThikness/KlischeThikness.js")
);
const LazyHalftone = React.lazy(() =>
  import("../scenes/ConsumableMaterial/Halftone/Halftone.js")
);

const LazyTram = React.lazy(() =>
  import("../scenes/ConsumableMaterial/Tram/Tram.js")
);
const LazyLpi = React.lazy(() =>
  import("../scenes/ConsumableMaterial/Lpi/LpiDefine")
);
const LazyDpi = React.lazy(() =>
  import("../scenes/ConsumableMaterial/Dpi/DpiDefine")
);
const lazyStep = React.lazy(() =>
  import("../scenes/ConsumableMaterial/Steps/Steps")
);
const lazyQcItems = React.lazy(() =>
  import("../scenes/ConsumableMaterial/QcItems/QcItems")
);
const LazyKiledcheAndThikness = React.lazy(() =>
  import("../scenes/ConsumableMaterial/KiledcheAndThikness/KiledcheAndThikness")
);
const LazyAssembly = React.lazy(() =>
  import("../scenes/Production/Assembly/Assembly")
);
const LazyPacking = React.lazy(() =>
  import("../scenes/Production/Packing/Packing")
);
const LazyOrderSend = React.lazy(() =>
  import("../scenes/Production/Send/OrderSend")
);
const LazyOrderCutting = React.lazy(() =>
  import("../scenes/Production/Cutting/Cutting.jsx")
);

/*================================ OrganizationDefinitions ==============================*/
const LazyChart = React.lazy(() =>
  import("../scenes/Organization/Chart/Chart.js")
);
const LazyTeams = React.lazy(() =>
  import("../scenes/OrganizationDefinitions/Teams/Teams.js")
);
const LazyRoles = React.lazy(() =>
  import("../scenes/OrganizationDefinitions/Roles/Roles.js")
);
const LazyUnits = React.lazy(() =>
  import("../scenes/OrganizationDefinitions/Units/Units.js")
);
const LazyEmployeeRegistration = React.lazy(() =>
  import(
    "../scenes/OrganizationDefinitions/EmployeeRegistration/EmployeeRegistration.js"
  )
);
const LazyCreateUserAccount = React.lazy(() =>
  import(
    "../scenes/OrganizationDefinitions/CreateUserAccount/CreateUserAccount.js"
  )
);

const LazyKlischeDimensions = React.lazy(() =>
  import("../scenes/ConsumableMaterial/KlischeDimensions/KlischeDimensions.js")
);
const LazyKlischePrice = React.lazy(() =>
  import("../scenes/ConsumableMaterial/KlischePrice/KlischePrice.js")
);
const LazyCreateAccount = React.lazy(() =>
  import("../scenes/OrganizationDefinitions/UserAccount/UserAccount")
);
const LazyPositionsDefinition = React.lazy(() =>
  import(
    "../scenes/OrganizationDefinitions/PositionsDefinition/PositionsDefinition.js"
  )
);
const LazyWorkingGroups = React.lazy(() =>
  import("../scenes/OrganizationDefinitions/WorkingGroups/WorkingGroups.js")
);
const LazyContracts = React.lazy(() =>
  import("../scenes/OrganizationDefinitions/Contracts/Contracts.js")
);
const LazyEmployment = React.lazy(() =>
  import(
    "../scenes/OrganizationDefinitions/DefinitionEmployment/DefinitionEmployment.js"
  )
);
const LazyPostDefinition = React.lazy(() =>
  import("../scenes/OrganizationDefinitions/PostDefinition/PostDefinition.js")
);
const LazyBankInfo = React.lazy(() =>
  import("../scenes/OrganizationDefinitions/BankInfo/BankInfoCRD.js")
);
const LazyBankAccount = React.lazy(() =>
  import(
    "../scenes/OrganizationDefinitions/BankInfo/AccountBank/AccountBank.jsx"
  )
);
const LazyChequeBook = React.lazy(() =>
  import("../scenes/OrganizationDefinitions/BankInfo/ChequeBook/ChequeBook.js")
);
const LazyInsuranceJob = React.lazy(() =>
  import("../scenes/OrganizationDefinitions/InsuranceJob/InsuranceJob.js")
);
const LazyTypeInsurance = React.lazy(() =>
  import("../scenes/OrganizationDefinitions/TypeInsurance/TypeInsurance.js")
);
const LazyFiscalYear = React.lazy(() =>
  import("../scenes/OrganizationDefinitions/FiscalYear/FiscalYear.js")
);
const LazyChartType = React.lazy(() =>
  import("../scenes/OrganizationDefinitions/DefinitionChartType/ChartType.js")
);
const LazyPostType = React.lazy(() =>
  import(
    "../scenes/OrganizationDefinitions/DefinitionPostType/DefinitionPostType.js"
  )
);

const LazyProductionQualityControl = React.lazy(() =>
  import(
    "../scenes/Production/ProductionQualityControl/ProductionQualityControl"
  )
);
const LazyDesignerGroup = React.lazy(() =>
  import("../scenes/OrganizationDefinitions/DesignerGroup/index.js")
);
const LazySystemInformation = React.lazy(() =>
  import("../scenes/OrganizationDefinitions/SystemInformation/index.jsx")
);
const LazyDefinitionForm = React.lazy(() =>
  import("../scenes/OrganizationDefinitions/DefinitionForm/DefinitionForm.jsx")
);
const LazyDefinitionEnumOption = React.lazy(() =>
  import(
    "../scenes/OrganizationDefinitions/DefinitionEnumOption/EnumOption.jsx"
  )
);
const LazyProformaInvoiceProduction = React.lazy(() =>
  import(
    "../scenes/OrganizationDefinitions/ProformaInvoice/ProformaInvoiceProduction.jsx"
  )
);
const LazyMessages = React.lazy(() =>
  import("../scenes/OrganizationDefinitions/Messages/Messages.jsx")
);
const LazyAnnouncement = React.lazy(() =>
  import("../scenes/OrganizationDefinitions/Announcement/Announcement.jsx")
);
const LazyAnnouncementLogin = React.lazy(() =>
  import(
    "../scenes/OrganizationDefinitions/AnnouncementLogin/AnnouncementLogin.jsx"
  )
);
const LazyAccesGroups = React.lazy(() =>
  import("../scenes/OrganizationDefinitions/AccessGroups/AccessGroups.jsx")
);
/*================================ warehouse ==============================*/
const LazyInProgresswarehouse = React.lazy(() =>
  import("../scenes/warehouse/InProgresswarehouse/index.js")
);

const LazyRequestwarehouse = React.lazy(() =>
  import("../scenes/warehouse/RequestWarehouse/RequestWarehouseGrid.jsx")
);
const LazyPartialMaterial = React.lazy(() =>
  import("../scenes/warehouse/PartialMaterial/PartialMaterial.jsx")
);
const LazyConsumerGoods = React.lazy(() =>
  import("../scenes/warehouse/ConsumerGoods/ConsumerGoods.jsx")
);
// LazyFailureInvestigation

const LazyMainProductionQc = React.lazy(() =>
  import("../scenes/Production/MainProductionQc/MainProductionQc")
);
const LazyNotFoundPage = React.lazy(() =>
  import("../Pages/PageLackOfAccess.jsx")
);

const LazyReports = React.lazy(() => import("../scenes/Reports/Reports"));
const LazyReportCharts = React.lazy(() =>
  import("../scenes/Reports/Charts/Charts")
);
const LazyAllReports = React.lazy(() =>
  import("../scenes/Reports/AllReports/AllReports")
);
/*================== Report List Components =================*/

const LazyListReports = React.lazy(() =>
  import("../scenes/Reports/ReportList/ReportList.jsx")
);
const LazyListReportOrder = React.lazy(() =>
  import("../scenes/Reports/ReportList/ReListByOrders/index.jsx")
);
const LazyListPrInvoice = React.lazy(() =>
  import("../scenes/Reports/ReportList/ReListByPreInvoice/index.jsx")
);
const LazyListReportDevice = React.lazy(() =>
  import("../scenes/Reports/ReportList/ReListByDevice/index.jsx")
);
const LazyListReportInvoice = React.lazy(() =>
  import("../scenes/Reports/ReportList/ReListInvoice/index.jsx")
);
const LazychartReportView = React.lazy(() =>
  import("../scenes/Reports/ChartsReportView/index.jsx")
);
const LazyListReportLeaves = React.lazy(() =>
  import("../scenes/Reports/ReportList/ReportListPersonLeaves/index.jsx")
);
/*================================ Person Cartable ==============================*/
const lazyCartablePersonRecive = React.lazy(() =>
  import("../scenes/PersonFroms/ReciveCartablePerson/ReciveCartablePerson.jsx")
);
const lazyCartablePersonArchive = React.lazy(() =>
  import("../scenes/PersonFroms/ArciveCartablePerson/ArciveCartablePerson.jsx")
);
const lazyCartablePersonReferred = React.lazy(() =>
  import("../scenes/PersonFroms/ReferredCartablePerson/Referred.jsx")
);
const lazyRollCall = React.lazy(() =>
  import("../scenes/PersonFroms/RollCall/RollCall.jsx")
);
const lazyFunctionDesignersReport = React.lazy(() =>
  import("../scenes/PersonFroms/FunctionDesignersReport/index.js")
);
const lazyConsignment = React.lazy(() =>
  import("../scenes/PersonFroms/Consignment/Consignment.jsx")
);
const lazyIncomingGuest = React.lazy(() =>
  import("../scenes/PersonFroms/IncomingGuest/IncomingGuest.jsx")
);
const LazySecurityReport = React.lazy(() =>
  import("../scenes/PersonFroms/SecurityReport/SecurityReport.jsx")
);
const LazyPhoneBook = React.lazy(() =>
  import("../scenes/PersonFroms/PhoneBook/PhoneBook.jsx")
);
const LazyAllPersonCartable = React.lazy(() =>
  import("../scenes/PersonFroms/AllPersonCartable/AllPersonCartable.jsx")
);
const LazyCorrespondencePriceNotification = React.lazy(() =>
  import("../scenes/Correspondence/index.js")
);
const LazyEscrowExit = React.lazy(() =>
  import("../scenes/PersonFroms/EscrowExitTotal/EscrowExit.jsx")
);
const LazyOrderDiffrents = React.lazy(() =>
  import("../scenes/OrderPayment/OrderDiffrents/OrderDiffrents")
);
const LazyFinancialScheduler = React.lazy(() =>
  import("../scenes/Financial/Scheduler/index")
);
const LazyOrderReturn = React.lazy(() =>
  import("../scenes/OrderReturn/OrderReturn")
);

const LazyUnspecifiedPayments = React.lazy(() =>
  import("../scenes/UnspecifiedPayments/index")
);
const LazyReceipts = React.lazy(() =>
  import("../scenes/Financial/Receipt/Receipts.js")
);



const LazyCustomerPerformanceStatus = React.lazy(() =>  
import("../scenes/CustomerPerformanceStatus/index.js")
);

const Loading = () => {
  return (
    <div
      style={{
        width: "100%",
        height: "600px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <CircularProgress />
    </div>
  );
};

const LazyComponent = ({ component: Component, ...props }) => (
  <Suspense fallback={<Loading />}>
    <Component {...props} />
  </Suspense>
);
/*================================ Define Routes ==============================*/
// LazyScheduler
const routes = [
  { path: "overview", element: <OverView /> },
  { path: "scheduler", element: <LazyComponent component={LazyScheduler} /> },
  { path: "orders", element: <LazyComponent component={LazyOrders} /> },
  { path: "designer", element: <LazyComponent component={LazyDesigner} /> },
  { path: "qc", element: <LazyComponent component={LazyQc} /> },
  { path: "analog", element: <LazyComponent component={LazyLaser} /> },
  {
    path: "printAssistant",
    element: <LazyComponent component={LazyAssistant} />,
  },

  {
    path: "digital",
    element: <LazyComponent component={LazyLaserDigital} />,
  },
  { path: "rep", element: <LazyComponent component={LazyRep} /> },

  {
    path: "customers",
    element: <LazyComponent component={LazyQualityControl} />,
  },
  {
    path: "salesLead",
    element: <LazyComponent component={LazyClueCustomer} />,
  },

  {
    path: "archiveOrder",
    element: <LazyComponent component={LazyOrderArchive} />,
  },
  { path: "sales", element: <LazyComponent component={LazySales} /> },
  { path: "teams", element: <LazyComponent component={LazyTeams} /> },
  { path: "departmans", element: <LazyComponent component={LazyUnits} /> },
  { path: "roles", element: <LazyComponent component={LazyRoles} /> },
  { path: "chart", element: <LazyComponent component={LazyChart} /> },

  {
    path: "createUserAccount",
    element: <LazyComponent component={LazyCreateAccount} />,
  },
  {
    path: "employeeRegistration",
    element: <LazyComponent component={LazyEmployeeRegistration} />,
  },
  {
    path: "createEmployeesAccount",
    element: <LazyComponent component={LazyCreateUserAccount} />,
  },
  {
    path: "PositionsDefinition",
    element: <LazyComponent component={LazyPositionsDefinition} />,
  },
  {
    path: "PostDefinition",
    element: <LazyComponent component={LazyPostDefinition} />,
  },
  {
    path: "WorkingGroups",
    element: <LazyComponent component={LazyWorkingGroups} />,
  },
  { path: "Contracts", element: <LazyComponent component={LazyContracts} /> },
  {
    path: "definitionEmployment",
    element: <LazyComponent component={LazyEmployment} />,
  },
  { path: "chart", element: <LazyComponent component={LazyChart} /> },
  {
    path: "onlineOrder",
    element: <LazyComponent component={LazyOnlineOrder} />,
  },
  {
    path: "definitionKlische",
    element: <LazyComponent component={LazyDefinitionKlische} />,
  },
  {
    path: "klischeThikness",
    element: <LazyComponent component={LazyKlischeThikness} />,
  },
  {
    path: "infoMachine",
    element: <LazyComponent component={LazyInfoMachine} />,
  },
  {
    path: "trams",
    element: <LazyComponent component={LazyTram} />,
  },
  {
    path: "steps",
    element: <LazyComponent component={lazyStep} />,
  },
  {
    path: "KlischeDimensions",
    element: <LazyComponent component={LazyKlischeDimensions} />,
  },
  {
    path: "KlischePrice",
    element: <LazyComponent component={LazyKlischePrice} />,
  },
  {
    path: "assembly",
    element: <LazyComponent component={LazyAssembly} />,
  },
  {
    path: "packing",
    element: <LazyComponent component={LazyPacking} />,
  },
  {
    path: "productionQC",
    element: <LazyComponent component={lazyProductionQC} />,
  },
  {
    path: "financial",
    element: <LazyComponent component={lazyFinancial} />,
  },
  {
    path: "send",
    element: <LazyComponent component={LazyOrderSend} />,
  },
  { path: "halftone", element: <LazyComponent component={LazyHalftone} /> },
  { path: "bankInfo", element: <LazyComponent component={LazyBankInfo} /> },
  {
    path: "bankAccount",
    element: <LazyComponent component={LazyBankAccount} />,
  },
  {
    path: "cheqeBook",
    element: <LazyComponent component={LazyChequeBook} />,
  },

  {
    path: "insuranceJob",
    element: <LazyComponent component={LazyInsuranceJob} />,
  },
  {
    path: "TypeInsurance",
    element: <LazyComponent component={LazyTypeInsurance} />,
  },
  {
    path: "KiledcheAndThikness",
    element: <LazyComponent component={LazyKiledcheAndThikness} />,
  },
  {
    path: "lpi",
    element: <LazyComponent component={LazyLpi} />,
  },
  {
    path: "dpi",
    element: <LazyComponent component={LazyDpi} />,
  },
  {
    path: "qcItems",
    element: <LazyComponent component={lazyQcItems} />,
  },
  {
    path: "plates",
    element: <LazyComponent component={lazyPlates} />,
  },
  {
    path: "causesFailure",
    element: <LazyComponent component={lazyCausesFailure} />,
  },
  {
    path: "fiscalYear",
    element: <LazyComponent component={LazyFiscalYear} />,
  },
  {
    path: "chartType",
    element: <LazyComponent component={LazyChartType} />,
  },
  {
    path: "PostType",
    element: <LazyComponent component={LazyPostType} />,
  },
  {
    path: "GroupDesigner",
    element: <LazyComponent component={LazyDesignerGroup} />,
  },
  {
    path: "productionQualityControl",
    element: <LazyComponent component={LazyProductionQualityControl} />,
  },
  {
    path: "MainProductionQc",
    element: <LazyComponent component={LazyMainProductionQc} />,
  },
  {
    path: "FailureInvestigation/mainPage",
    element: <LazyComponent component={LazyFailureInvestigation} />,
  },
  {
    path: "FailureInvestigation/manager",
    element: <LazyComponent component={LazyManagerLazyFailureInvestigation} />,
  },
  {
    path: "FailureInvestigation/archived",
    element: <LazyComponent component={LazyArchivedPlateDamaged} />,
  },
  {
    path: "warehouse/progresswarehouse",
    element: <LazyComponent component={LazyInProgresswarehouse} />,
  },
  {
    path: "warehouse/RequestWarehouse",
    element: <LazyComponent component={LazyRequestwarehouse} />,
  },
  {
    path: "warehouse/partialMaterial",
    element: <LazyComponent component={LazyPartialMaterial} />,
  },

  // {
  //   path: "reports/reports",
  //   element: <LazyComponent component={LazyReports} />,
  // },
  {
    path: "reports/reportcharts",
    element: <LazyComponent component={LazyReportCharts} />,
  },
  {
    path: "reports/allreports",
    element: <LazyComponent component={LazyReportCharts} />,
  },
  {
    path: "reports",
    element: <LazyComponent component={LazyReports} />,
  },
  {
    path: "reports/listReports/orders",
    element: <LazyComponent component={LazyListReportOrder} />,
  },
  {
    path: "reports/listReports/preInvoice",
    element: <LazyComponent component={LazyListPrInvoice} />,
  },
  {
    path: "reports/listReports/device",
    element: <LazyComponent component={LazyListReportDevice} />,
  },
  {
    path: "reports/listReports/invoice",
    element: <LazyComponent component={LazyListReportInvoice} />,
  },
  {
    path: "reports/chartReportView",
    element: <LazyComponent component={LazychartReportView} />,
  },
  {
    path: "reports/listReports/personLeave",
    element: <LazyComponent component={LazyListReportLeaves} />,
  },
  {
    path: "403",
    element: <LazyComponent component={LazyNotFoundPage} />,
  },
  {
    path: "systemInformation",
    element: <LazyComponent component={LazySystemInformation} />,
  },
  {
    path: "ticket",
    element: <LazyComponent component={LazyTicket} />,
  },
  {
    path: "form",
    element: <LazyComponent component={LazyDefinitionForm} />,
  },
  {
    path: "formSend",
    element: <LazyComponent component={lazySentCartablePerson} />,
  },
  {
    path: "formRecive",
    element: <LazyComponent component={lazyCartablePersonRecive} />,
  },
  {
    path: "formArchive",
    element: <LazyComponent component={lazyCartablePersonArchive} />,
  },
  {
    path: "formReferred",
    element: <LazyComponent component={lazyCartablePersonReferred} />,
  },
  {
    path: "enumOption",
    element: <LazyComponent component={LazyDefinitionEnumOption} />,
  },
  {
    path: "formAfzarOrders",
    element: <LazyComponent component={LazyFormAfzarOrders} />,
  },
  {
    path: "rollcall",
    element: <LazyComponent component={lazyRollCall} />,
  },
  {
    path: "consignment",
    element: <LazyComponent component={lazyConsignment} />,
  },
  {
    path: "incomingGuest",
    element: <LazyComponent component={lazyIncomingGuest} />,
  },
  {
    path: "securityReport",
    element: <LazyComponent component={LazySecurityReport} />,
  },
  {
    path: "phoneBook",
    element: <LazyComponent component={LazyPhoneBook} />,
  },
  {
    path: "warehouse/consumerGoods",
    element: <LazyComponent component={LazyConsumerGoods} />,
  },
  {
    path: "proformaInvoiceProduction",
    element: <LazyComponent component={LazyProformaInvoiceProduction} />,
  },
  {
    path: "getAllPersonCartable",
    element: <LazyComponent component={LazyAllPersonCartable} />,
  },
  {
    path: "messages",
    element: <LazyComponent component={LazyMessages} />,
  },
  {
    path: "announcement",
    element: <LazyComponent component={LazyAnnouncement} />,
  },
  {
    path: "OrderCutting",
    element: <LazyComponent component={LazyOrderCutting} />,
  },
  {
    path: "colorAngle",
    element: <LazyComponent component={LazyColorAngle} />,
  },
  {
    path: "announcementLogin",
    element: <LazyComponent component={LazyAnnouncementLogin} />,
  },
  {
    path: "letters",
    element: <LazyComponent component={LazyLetters} />,
  },
  {
    path: "correspondencePriceNotification",
    element: <LazyComponent component={LazyCorrespondencePriceNotification} />,
  },
  /*======= Mobile Route =======*/
  {
    path: "menu",
    element: <LazyComponent component={menu} />,
  },
  {
    path: "mobileNotifcation",
    element: <LazyComponent component={mobileNotifcation} />,
  },
  /*======= Order payment =======*/
  {
    path: "depositDocument",
    element: <LazyComponent component={LazyDepositDocument} />,
  },
  {
    path: "orderPaymentFinancial",
    element: <LazyComponent component={LazyOrderPaymentFinancial} />,
  },
  {
    path: "orderPaymentArchive",
    element: <LazyComponent component={LazyOrderPaymentArchive} />,
  },
  {
    path: "orderDamage/manager",
    element: <LazyComponent component={lazyOrderDamageManager} />,
  },
  ,
  {
    path: "orderDamage/financial",
    element: <LazyComponent component={lazyOrderDamageFinancial} />,
  },
  {
    path: "orderDamage/archived",
    element: <LazyComponent component={lazyOrderDamageArchived} />,
  },
  {
    path: "orderDamage/supervisor",
    element: <LazyComponent component={lazyOrderDamageSupervisor} />,
  },
  {
    path: "orderDamage/MainPage",
    element: <LazyComponent component={lazyOrderDamageMainPage} />,
  },
  {
    path: "escrowExit",
    element: <LazyComponent component={LazyEscrowExit} />,
  },
  /*================== Financial =================*/
  {
    path: "financial/FinancialTransaction",
    element: <LazyComponent component={LazyFinancialTransaction} />,
  },
  {
    path: "CustomerArchivedOrders",
    element: <LazyComponent component={lazyCustomerArchivedOrders} />,
  },
  {
    path: "financial/MafsaInsuranceReport",
    element: <LazyComponent component={LazyMafsaInsuranceReport} />,
  },
  {
    path: "accessGroups",
    element: <LazyComponent component={LazyAccesGroups} />,
  },

  {
    path: "damageCorrectiveAction",
    element: <LazyComponent component={LazDamageCorrectiveAction} />,
  },
  {
    path: "financialTransactionCategory",
    element: <LazyComponent component={LazyFinancialTransactionCategory} />,
  },
  {
    path: "calenderEvent",
    element: <LazyComponent component={LazyCalenderEvent} />,
  },
  {
    path: "listOfLoan",
    element: <LazyComponent component={LazyListOfLoan} />,
  },
  {
    path: "pettyCashList",
    element: <LazyComponent component={LazyPettyCashList} />,
  },
  {
    path: "ReasonsCancellationFailure",
    element: <LazyComponent component={lazyReasonsCancellationFailure} />,
  },
  {
    path: "orderDiffrents",
    element: <LazyComponent component={LazyOrderDiffrents} />,
  },
  {
    path: "functionDesignersReport",
    element: <LazyComponent component={lazyFunctionDesignersReport} />,
  },
  {
    path: "financial/scheduler",
    element: <LazyComponent component={LazyFinancialScheduler} />,
  },
  {
    path: "orderReturn",
    element: <LazyComponent component={LazyOrderReturn} />,
  },
  {
    path: "unspecifiedPayments",
    element: <LazyComponent component={LazyUnspecifiedPayments} />,
  },
    {
    path: "customerPerformanceStatus",
    element: <LazyComponent component={LazyCustomerPerformanceStatus} />,
  },
  ,
    {
    path: "financial/receipts",
    element: <LazyComponent component={LazyReceipts} />,
  }
  ,
    {
    path: "financial/financialReportChart",
    element: <LazyComponent component={LazyFinancialReportCharts} />,
  },
];
// LazyFinancialReportCharts

const DashRoutes = () => {
  return (
    <>
      <Routes>
        <Route path="/dashboard" element={<Dashboard />}>
          {routes.map(({ path, element }, index) => (
            <Route key={index} path={path} element={element} />
          ))}
        </Route>
        {token !== null && <Route path="*" element={<NotFound />} />}{" "}
      </Routes>
    </>
  );
};

export default DashRoutes;

// LazDamageCorrectiveAction


// const LazyUnspecifiedPayments = React.lazy(() =>
//   import("../scenes/UnspecifiedPayments/UnspecifiedPayments")
// );